module.exports = __webpack_public_path__ + "img/img_1_.2eac34e9.png";